import { IItem } from 'models/item';
import { TConcept } from 'types';
import { createBaseItemInteraction, BaseItemServiceParams } from './baseItemInteraction';

export type Flashcards = {
  id: string;
  templateType: 'associations';
  rawItem: IItem;
  updateRawItem: (newRawItem: IItem) => void;
  updateConceptLocally: (conceptId: string, updates: Partial<TConcept>) => void;
};

export default function flashcards(params: BaseItemServiceParams): Flashcards {
  return createBaseItemInteraction(params, 'associations') as Flashcards;
}